/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainEntitiesPlutusPaymentStatus {
    Created = 0,
    Payed = 1,
    Cancelled = 2,
    Unknown = 99,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainEntitiesPlutusPaymentStatus(value: any): boolean {
    for (const key in FxIdDomainEntitiesPlutusPaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesPlutusPaymentStatus, key)) {
            if (FxIdDomainEntitiesPlutusPaymentStatus[key as keyof typeof FxIdDomainEntitiesPlutusPaymentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainEntitiesPlutusPaymentStatusFromJSON(json: any): FxIdDomainEntitiesPlutusPaymentStatus {
    return FxIdDomainEntitiesPlutusPaymentStatusFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesPlutusPaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesPlutusPaymentStatus {
    return json as FxIdDomainEntitiesPlutusPaymentStatus;
}

export function FxIdDomainEntitiesPlutusPaymentStatusToJSON(value?: FxIdDomainEntitiesPlutusPaymentStatus | null): any {
    return value as any;
}

export function FxIdDomainEntitiesPlutusPaymentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesPlutusPaymentStatus {
    return value as FxIdDomainEntitiesPlutusPaymentStatus;
}

